import "./Intro.scss";
import Tags from "../../UI/Tags/Tags";
import Counts from "../../UI/Counts/Counts";
import UserCard from "../../UI/UserCard/UserCard";
import myPhoto from "/images/photo.jpeg";
import myPhotoWebp from "/images/photo.webp";
import Icon from "../../UI/Icon/Icon";
import { useState } from "react";
import ModalForm from "../../UI/ModalForm/ModalForm";
import ShinyText from "../../UI/ShinyText/ShinyText";
import BorderCircle from "../../UI/BorderCircle/BorderCircle";
import { MarqueeLine1, MarqueeLine2 } from "../../UI/MarqueeLine/MarqueeLine";

const Intro = () => {
  // const [modal, setModal] = useState({
  //   isOpen: false,
  // });

  // const talkMe = () => {
  //   // console.log("Написать мне");
  //   setModal({
  //     isOpen: true,
  //   });
  // };

  const [isModalOpen, setIsModalOpen] = useState(false);

  // const talkMe = () => setIsModalOpen(true);
  // const closeModal = () => setIsModalOpen(false);

  // const closeModal = () => setModal({ ...modal, isOpen: false });

  return (
    <>
      <section className="intro" id="intro" style={{ position: "relative" }}>
        <div className="container container--sm">
          <div
            className="intro__wrapper"
            style={{ position: "relative", zIndex: "2" }}
          >
            <h2 className="intro__title">Developer</h2>
            <div className="intro__content">
              <BorderCircle className="radius">
                <UserCard
                  imageUrl={myPhoto}
                  imageUrlWebp={myPhotoWebp}
                  userName="Артем"
                  proffesion="Frontend-разработчик"
                />
              </BorderCircle>

              <div className="intro__inner">
                <div className="intro__inner-text">
                  <h3 className="intro__subtitle">
                    <Tags tag="h1" />
                    <br></br>
                    Привет я <span>Артём</span>, Frontend-разработчик
                    <Tags tag="h1/" className="ml-20px" />
                  </h3>
                  <p className="intro__description">
                    <Tags tag="p" />
                    <br></br>
                    Делаю интерфейсы, которыми приятно пользоваться. Я тот, кому
                    нравится доводить проекты до идеала — от первого макета до
                    запуска онлайн.
                    <br></br>
                    <Tags tag="p/" />
                  </p>

                  <ShinyText
                    disabled={false}
                    speed={3}
                    className="intro__button"
                    type="button"
                    onClick={() => setIsModalOpen(true)}
                  >
                    <span className="intro__button-text">Написать</span>
                    <Icon
                      className="intro__button-icon"
                      id="icon-mail"
                      width="24"
                      height="24"
                    />
                  </ShinyText>
                </div>
                <Counts />
              </div>
            </div>
          </div>
        </div>
      </section>
      <MarqueeLine1 />
      <MarqueeLine2 />
      <ModalForm isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default Intro;
